function TranslateDirective($compile, translateService){
    return {
        restrict: 'A',
        transclude: true,
        scope: {
            name: '='
        },
        link: function($scope, $element, attr, ParentDirectCtrl, $transclude){
            $scope.translateService = translateService;
            $transclude($scope, function(clone, scope){
                let text = clone.text();
                if(text){
                    let translation = translateService.translate(text);
                    if(clone[0].nodeName !== '#text') {
                        clone.html(translation);
                        let compiled = $compile(clone)(scope);
                        $element.empty();
                        $element.append(compiled);
                    }
                    else {
                        $element.text(translation);
                    }
                }
            });
            if(attr.value) {
                $element.val(translateService.translate(attr.value));
            }
        }
    }
}

TranslateDirective.$inject = ['$compile', 'translateService'];

module.exports = TranslateDirective;


// WEBPACK FOOTER //
// ./src/azurebackup/components/translateDirective/translate.directive.js